<template>
  <div class="codePage">
    <div class="codePage__inner">
      <div class="codePage__title">
        <span>ProntoQ.</span> Система управления электронной очередью
      </div>
      <div class="codePage__block">
        <div class="codePage__block__title">
          Код сопряжения:
        </div>
        <div class="codePage__block__code">
          <span>{{ code }}</span>
        </div>
        <div class="codePage__block__status">
          <ul class="codePage__block__status__inner">
            <li>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.3333 10.6665H28C28.3536 10.6665 28.6928 10.807 28.9428 11.057C29.1929 11.3071 29.3333 11.6462 29.3333 11.9998V27.9998C29.3333 28.3535 29.1929 28.6926 28.9428 28.9426C28.6928 29.1927 28.3536 29.3332 28 29.3332H17.3333C16.9797 29.3332 16.6406 29.1927 16.3905 28.9426C16.1405 28.6926 16 28.3535 16 27.9998V26.6665H5.33333C4.97971 26.6665 4.64057 26.526 4.39052 26.276C4.14048 26.0259 4 25.6868 4 25.3332V3.99984C4 3.64622 4.14048 3.30708 4.39052 3.05703C4.64057 2.80698 4.97971 2.6665 5.33333 2.6665H24C24.3536 2.6665 24.6928 2.80698 24.9428 3.05703C25.1929 3.30708 25.3333 3.64622 25.3333 3.99984V10.6665ZM22.6667 10.6665V5.33317H6.66667V23.9998H16V11.9998C16 11.6462 16.1405 11.3071 16.3905 11.057C16.6406 10.807 16.9797 10.6665 17.3333 10.6665H22.6667ZM18.6667 13.3332V26.6665H26.6667V13.3332H18.6667Z"
                  fill="#3C3C43"
                />
              </svg>
            </li>
            <li>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.4852 20.7147L22.5999 18.8267L24.4852 16.9413C25.1087 16.3232 25.604 15.5881 25.9426 14.7781C26.2812 13.9681 26.4566 13.0992 26.4585 12.2213C26.4604 11.3433 26.2889 10.4737 25.9538 9.66219C25.6187 8.85072 25.1267 8.11342 24.5059 7.49263C23.8851 6.87183 23.1478 6.37977 22.3363 6.04469C21.5248 5.7096 20.6552 5.5381 19.7772 5.54002C18.8993 5.54194 18.0304 5.71725 17.2204 6.05589C16.4104 6.39452 15.6753 6.88981 15.0572 7.51332L13.1719 9.39998L11.2852 7.51465L13.1732 5.62932C14.9236 3.87889 17.2977 2.89551 19.7732 2.89551C22.2487 2.89551 24.6228 3.87889 26.3732 5.62932C28.1236 7.37975 29.107 9.75384 29.107 12.2293C29.107 14.7048 28.1236 17.0789 26.3732 18.8293L24.4865 20.7147H24.4852ZM20.7145 24.4853L18.8279 26.3707C17.0774 28.1211 14.7033 29.1045 12.2279 29.1045C9.75237 29.1045 7.37828 28.1211 5.62785 26.3707C3.87742 24.6202 2.89404 22.2461 2.89404 19.7707C2.89404 17.2952 3.87742 14.9211 5.62785 13.1707L7.51452 11.2853L9.39985 13.1733L7.51452 15.0587C6.89101 15.6767 6.39572 16.4119 6.05709 17.2219C5.71846 18.0319 5.54315 18.9008 5.54122 19.7787C5.5393 20.6566 5.7108 21.5263 6.04589 22.3378C6.38097 23.1492 6.87303 23.8865 7.49383 24.5073C8.11462 25.1281 8.85192 25.6202 9.6634 25.9553C10.4749 26.2904 11.3445 26.4619 12.2225 26.4599C13.1004 26.458 13.9693 26.2827 14.7793 25.9441C15.5893 25.6054 16.3244 25.1102 16.9425 24.4867L18.8279 22.6013L20.7145 24.4867V24.4853ZM19.7705 10.3427L21.6572 12.2293L12.2292 21.656L10.3425 19.7707L19.7705 10.344V10.3427Z"
                  fill="#34C759"
                />
              </svg>
            </li>
            <li>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.3335 6.66667V21.3333H26.6668V6.66667H5.3335ZM2.66683 5.34267C2.66683 4.60133 3.2735 4 3.9895 4H28.0108C28.7415 4 29.3335 4.59867 29.3335 5.34267V24H2.66683V5.34267ZM1.3335 25.3333H30.6668V28H1.3335V25.3333Z"
                  fill="#3C3C43"
                />
              </svg>
            </li>
          </ul>
        </div>
      </div>
      <div class="codePage__footer">
        &copy; {{ year }} ProntoQ
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodePage',
  data() {
    return {
      code: null,
      token: localStorage.getItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.DEVICE_TOKEN),
      socketMessageUnsubscription: null,
      socketOpenUnsubscription: null,
      year: new Date().getFullYear(),
    }
  },
  mounted() {
    if (this.token) {
      this.openDevice();
    } else {
      this.$socketService.connect(this.$deviceConfig.SOCKET_URL, this.$deviceConfig.SOCKET_DEVICE_PARAM);

      this.socketOpenUnsubscription = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.SOCKETS_OPEN, () => {
        this.$crudService.get('device/code').then(({data}) => {
          this.code = data;
          this.$initService.authorizeDeviceByCode(this.code);
        });

        this.socketMessageUnsubscription = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.SOCKETS_MESSAGE, data => {
          if (data.payload && data.payload.event_type) {
            if (data.payload.event_type === 1000) {
              const parsedDeviceData = JSON.parse(data.payload.payload);
              this.token = parsedDeviceData.token;

              localStorage.setItem(this.$deviceConfig.LOCALSTORAGE_CONSTANTS.DEVICE_TOKEN, this.token);
              this.$socketService.close();
              this.$socketService.webSocketReady = false;
              window.location.reload();
            }
          }
        })
      });
    }
  },
  destroyed() {
    if (this.socketMessageUnsubscription) this.socketMessageUnsubscription();
    if (this.socketOpenUnsubscription) this.socketOpenUnsubscription();
  },
  methods: {
    openDevice() {
      this.$emit('openDevice', this.token)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/variables";

  .codePage {
    background: #2C2C2E;
    text-align: center;
    &__inner {
      width: 100vw;
      height: 100vh;
      padding: 18px 0 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
    &__title {
      color: $color-grey-02;
      font-size: 22px;
      span {
        font-weight: 600;
      }
    }
    &__block {
      width: 100%;
      &__title {
        color: $color-accent-green;
        font-weight: 500;
        font-size: 42px;
        margin-bottom: 32px;
      }
      &__code {
        margin-bottom: 48px;
        span {
          font-weight: 600;
          font-size: 160px;
          letter-spacing: 30px;
          color: #fff;
          background: $color-accent-green;
          border-radius: 290px;
          width: 800px;
          height: 240px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-feature-settings: 'zero' on;
        }
      }
      &__status {
        &__inner {
          margin: 0;
          padding: 0;
          list-style: none;
          display: flex;
          align-items: center;
          justify-content: center;
          li {
            width: 64px;
            height: 64px;
            background: $color-light-01;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 40px;
            position: relative;
            &:nth-child(1),
            &:nth-child(2) {
              &::after {
                content: '';
                background: $color-light-01;
                width: 82px;
                height: 6px;
                left: 63px;
                top: 50%;
                margin-top: -3px;
                position: absolute;
              }
            }
            &:nth-child(1),
            &:nth-child(3) {
              background: $color-grey-04;
              svg {
                opacity: .6;
              }
            }
            &:nth-child(1) {
              &::after {
                background: linear-gradient(90deg, #D1D1D6 0%, #FFFFFF 100%);
              }
            }
            &:nth-child(2) {
              &::after {
                background: linear-gradient(-90deg, #D1D1D6 0%, #FFFFFF 100%);
              }
            }
          }
        }
      }
    }
    &__footer {
      color: $color-light-03;
      font-weight: 300;
      font-size: 16px;
      line-height: 150%;
    }
  }
</style>
